import { AxiosInstance } from "axios"
import { OrderForCalendar, ProductionSlip, ReportDetails } from "./ordersForCalendarTypes"

export enum MerchantOrdersForCalendarQuery {
    LIST = "merchant-orders-for-calendar",
}

type OrdersForCalendarParams = Readonly<{
    merchantId: number
    startDate: string
    endDate: string
}>

export type OrdersForCalendarResponse = Readonly<{
    reportDetails: ReportDetails | any
    orders: OrderForCalendar[]
}>

export async function fetchOrdersForCalendar(
    { merchantId, startDate, endDate }: OrdersForCalendarParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<OrdersForCalendarResponse> {
    const url = `/merchants/${merchantId}/production/meetingService/events`

    const { data } = await axios.get(url, {
        params: {
            startDate,
            endDate,
        },
        signal,
    })

    return data
}

type ProductionSlipParams = Readonly<{
    orderIds: number[]
}>

export type ProductionSlipResponse = Readonly<{
    orders: ProductionSlip[]
}>

export async function createProductionSlip(
    { orderIds }: ProductionSlipParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<ProductionSlipResponse> {
    const url = `/orders/batch/meetingService/productionSlip`

    const { data } = await axios.post(
        url,
        {
            orderIds,
        },
        {
            signal,
        },
    )

    return data
}
